var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.8935 1.33398H5.1135C2.8535 1.33398 1.3335 2.92065 1.3335 5.28065V10.7273C1.3335 13.0807 2.8535 14.6673 5.1135 14.6673H10.8935C13.1535 14.6673 14.6668 13.0807 14.6668 10.7273V5.28065C14.6668 2.92065 13.1535 1.33398 10.8935 1.33398Z",
    fill: "#EF0808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0105 9.18033L8.82455 7.995L10.0099 6.80967C10.2379 6.58233 10.2379 6.21233 10.0099 5.985C9.78188 5.75567 9.41322 5.75633 9.18522 5.98433L7.99922 7.16967L6.81322 5.983C6.58522 5.755 6.21588 5.75633 5.98788 5.983C5.76055 6.211 5.76055 6.581 5.98788 6.80833L7.17455 7.995L5.99055 9.17833C5.76255 9.40633 5.76255 9.77633 5.99055 10.003C6.10455 10.1177 6.25322 10.1743 6.40255 10.1743C6.55255 10.1743 6.70122 10.1177 6.81522 10.0037L7.99922 8.81967L9.18588 10.0057C9.29988 10.1197 9.44855 10.1763 9.59788 10.1763C9.74722 10.1763 9.89655 10.119 10.0105 10.0057C10.2385 9.77767 10.2385 9.40833 10.0105 9.18033Z",
    fill: "#EF0808"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.125fe5db8e79a6b4520b25e64b07b3fa.svg";
export { ForwardRef as ReactComponent };